import { Component, OnInit, Input } from '@angular/core';
import { OperatorService } from 'src/app/services/operator.service';
import { GlobalService } from 'src/app/services/global.service';
import { TicketService } from 'src/app/services/ticket.service';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OpenfolderComponent } from '../openfolder/openfolder.component';

@Component({
  selector: 'app-openticket',
  templateUrl: './openticket.component.html',
  styleUrls: ['./openticket.component.css']
})
export class OpenticketComponent implements OnInit {

  @Input() tk
  operators: Array<any>;
  token: string;
  ope: any;
  userActive: any;
  operator: boolean = false;
  op: any;
  take: boolean = false;

  constructor(
    private customerService: OperatorService,
    private globals: GlobalService,
    private ticketService: TicketService,
    private activeModal : NgbActiveModal,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    if(!this.token){
      this.token = this.globals.getToken();
    }
    this.userActive = this.globals.storagedUser;
    this.checkProfile();
    this.getOperators();
  }

  checkProfile(){
    if(this.userActive.profile_id > 1){
      this.operator = true;
    } else {
      this.operator = false;
    }
  }

  getOperators(){
    this.customerService.getOperator(this.token).subscribe(
      res => {

        this.operators = res;
      },
      err => {
        console.error("error on get Customers", err);

      }
    )
  }

  // Prendi incarico
  takeTicket(tk){
    // this.ticketService.assignTicket(this.token, tk.ticket_id, this.userActive.user_id).subscribe(
    //   res => {
    //     this.close();
    //   },
    //   err => {
    //     console.error("Errore nell'assegnare l'utente", err);
    //   }
    // )
    console.log("Take: ", this.take);
    if(this.take){
      this.take = false;
    } else {
      this.take = true;
    }
    this.operators.forEach((op) => {
      if(op.user_id == this.userActive.user_id){
        this.op = op;
      }
    })
  }


  assignTickets(tk, ope){
    this.ticketService.assignTicket(this.token, tk.ticket_id, ope.user_id).subscribe(
      res => {
        this.ticketService.setStatus(this.token,tk.ticket_id, {state: "In attesa"}).subscribe(
          res => {
            this.close();
          },
          err => {
            console.error("Errore nell'assegnare il ticket", err);
          }
        )
      },
      err => {
        console.error("Errore nell'assegnare l'utente", err);
      }
    )
  }

  showDoc(){
    const modalRef = this.modalService.open(OpenfolderComponent, { backdrop: 'static', centered: true, size: 'xl' })
    modalRef.componentInstance.folder_id = this.tk.folder_id;
    modalRef.result.then(result => {
      if (result != 'cancel') {
      }
    }, reason => {
    });
  }

  close(){
    this.activeModal.close();
  }
}
